import type { BasketResponse } from "@onestore/api/basket"
import getQuery from "@gatsby-plugin-bonus/lib/query-provider"
import queryString from "query-string"
import log from "~/lib/log"
import SessionStorage from "~/lib/storage/SessionStorage"

const STORAGE_KEY = "os_campaignPromoCode"

/**
 * Stores campaign promo code from URL query parameters into session storage.
 * If basket is currently empty, the promo code is stored in session storage and added to the basket when possible.
 */
export function setCampaignPromoCode() {
  const parsed = queryString.parse(getQuery(), {
    arrayFormat: "index",
  })

  const promoCode = parsed.campaign_promo_code

  if (typeof promoCode === "string" && promoCode.length > 0) {
    log(["storing promo code", promoCode], "promoCode")
    SessionStorage.set(STORAGE_KEY, promoCode)
  }
}

/**
 * Retrieves the stored campaign promo code from session storage.
 * Campaign promo code has higher priority than regular promo code.
 */
export function getCampaignPromoCode(): string | null {
  const storedCode = SessionStorage.get(STORAGE_KEY)
  if (typeof storedCode === "string" && storedCode.length > 0) {
    log(["reading promo code", storedCode], "promoCode")

    return storedCode
  }
  return null
}

/**
 * Removes the campaign promo code from session storage if it was applied successfully on basket.
 */
export function consumeCampaignPromoCode(
  result: BasketResponse,
  campaignPromoCode: string | null
) {
  if (campaignPromoCode) {
    if (result.promo_code === campaignPromoCode) {
      log(["consuming promo code"], "promoCode")
      SessionStorage.remove(STORAGE_KEY)
    }
  }
}
